import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  editorRoot: {
    '& .rdw-editor-toolbar': {
      color: '#000',
      marginBottom: 'unset',
      borderRadius: '4px 4px 0 0',
      padding: '15px 10px 10px',
    },
    '& .rdw-option-wrapper': {
      border: 'unset',
      borderRadius: 6,
      margin: 'unset',
      padding: 15,
    },
    '& .rdw-option-wrapper:hover': {
      boxShadow: 'unset',
      backgroundColor: '#f0f8ff',
    },
    '& .rdw-dropdown-wrapper': {
      border: 'unset',
      borderRadius: 6,
    },
    '& .rdw-dropdown-wrapper:hover': {
      boxShadow: 'unset',
      backgroundColor: '#f0f8ff',
    },
    '& .rdw-dropdown-carettoclose, .rdw-dropdown-carettoopen': {
      left: 'unset',
      right: '10%',
    },
    '& .rdw-editor-main': {
      borderRadius: '0 0 4px 4px',
      backgroundColor: '#f0f8ff',
      color: '#000',
    },
  },
}));
export default useStyles;
